/**
 * Las peticiones de cita que llegan desde la app del paciente.
 *
 * Quien las resuelve es quien agenda: se le da hora por el camino de siempre y
 * la solicitud se cierra apuntando a la cita que salió de ella. Así el paciente
 * ve en su app que lo que pidió el martes se convirtió en esto.
 */
import { apiFetch } from "./client";

export interface Solicitud {
  id: number;
  paciente_id: number;
  paciente_nombre: string;
  especialidad_id: number | null;
  especialidad: string | null;
  motivo: string;
  preferencia: string | null;
  /** El que dejó AL PEDIR, no el de su ficha de ahora. */
  telefono: string | null;
  estado: string;
  cita_id: number | null;
  respuesta: string | null;
  creada: string;
  atendida_en: string | null;
}

export function listSolicitudes(pendientes = true): Promise<Solicitud[]> {
  return apiFetch<Solicitud[]>(`/v1/solicitudes?pendientes=${pendientes}`);
}

/** La cierra enlazando la cita que ya se agendó por el camino de siempre. */
export function atenderSolicitud(id: number, citaId: number): Promise<Solicitud> {
  return apiFetch<Solicitud>(`/v1/solicitudes/${id}/atender`, {
    method: "POST",
    body: { cita_id: citaId },
  });
}

/** La cierra sin cita. El motivo es obligatorio: el paciente lo va a leer. */
export function descartarSolicitud(id: number, respuesta: string): Promise<Solicitud> {
  return apiFetch<Solicitud>(`/v1/solicitudes/${id}/descartar`, {
    method: "POST",
    body: { respuesta },
  });
}
